import {last} from '~ui/utils';

export const getNewSlug = (slug: string, targetClusterSlug: string, newName?: string) => {
    // it's impossible that we'll get `undefined` or empty string
    // from `last` call for 2 reasons:
    //  1. string.split always returns array with 1 item
    //  2. we could not have an empty page slug
    // Therefore we added `||` just to have correct typing
    const pageSlug = newName !== undefined ? newName : last(slug.split('/')) || '';

    return [targetClusterSlug, pageSlug].filter(Boolean).join('/');
};
